import * as types from '../constants/constants';

export function setMarkerActivity(bool) {
    return {
        type: types.MARKERS_ACTIVITY,
        bool
    }
}


export function setMarkerNow(index) {
    return {
        type: types.MARKER_NOW,
        index
    }
}


export function initImage(image) {
    return {
        type: types.IMAGE,
        image
    }
}

export function initLevel(level) {
    return {
        type: types.LEVEL,
        level
    }
}


export function initStateIFL(obj) {
    return {
        type: types.IFL_STATE,
        obj
    }
}

export function changeStep(step) {
    return {
        type: types.NOW_STEP,
        step
    }
}

export function updateImageLayout(imageLayout, index) {
    return {
        type: types.IMAGE_LAYOUT,
        imageLayout,
        index,
    }
}

export function initSliderState(sliderState) {
    return {
        type: types.SLIDER_STATE,
        sliderState
    }
}

export function initMarkerIndex(markerIndex) {
    return {
        type: types.MARKER_INDEX,
        markerIndex
    }
}

export function initPlaceHolderLayout(placeHolderLayout) {
    return {
        type: types.PLACE_HOLDER_LAYOUT,
        placeHolderLayout
    }
}

export function initScreenSize(screenSize) {
    return {
        type: types.SCREEN_SIZE,
        screenSize
    }
}